import React from 'react';
import { useNavigate } from 'react-router-dom';
import ClientNavbar from '../../components/client/ClientNavbar';
import Footer from '../../components/client/Footer';
import { blogArticles, getFeaturedArticle } from '../../data/blogArticles';

const Blog = () => {
  const navigate = useNavigate();
  const featuredArticle = getFeaturedArticle();
  const regularArticles = blogArticles.filter(article => !article.featured);


  const handleArticleClick = (slug) => {
    navigate(`/blog/${slug}`);
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <ClientNavbar />
      
      {/* Hero Section */}
      <div className="pt-20 pb-16 bg-gradient-to-br from-slate-900 via-slate-800 to-slate-700">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-5xl font-bold text-white mb-6">
            Blog RH & Recrutement
          </h1>
          <div className='mb-8'>
            <p className="text-xl text-slate-300 max-w-3xl mx-auto">
              Actualités, conseils et tendances pour optimiser vos pratiques de recrutement
            </p>
          </div>
        </div>
      </div>


      {/* Blog Posts Grid */}
<div className="pb-20 pt-20">
  <div className="container mx-auto px-4">
    <div className="grid md:grid-cols-3 gap-8 mb-16">
      {regularArticles.map((article) => (
        <article 
          key={article.id} 
          className=" rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition cursor-pointer group"
          onClick={() => handleArticleClick(article.slug)}
        >
          {/* Section image corrigée */}
          <div className="h-48 relative overflow-hidden">
            <img 
              src={article.image}
              alt={article.title}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
              
            />
            {/* Badge catégorie par-dessus l'image */}
            <div className="absolute top-4 left-4">
              <span className="bg-white bg-opacity-90 text-slate-700 text-xs px-2 py-1 rounded font-medium">
                {article.category}
              </span>
            </div>
          </div>
          
          {/* Contenu de l'article */}
          <div className="p-6">
            <div className="flex items-center justify-between mb-3">
              <span className="text-xs bg-gray-100 text-slate-600 px-2 py-1 rounded">
                {article.category}
              </span>
              <span className="text-xs text-slate-500">{article.readTime}</span>
            </div>
            <h3 className="text-lg font-semibold mb-3 hover:text-indigo-600 transition group-hover:text-indigo-600">
              {article.title}
            </h3>
            <p className="text-slate-600 text-sm mb-4">{article.excerpt}</p>
            <div className="flex items-center justify-between text-xs text-slate-500">
              <span>Par {article.author}</span>
              <span>{article.date}</span>
            </div>
          </div>
        </article>
      ))}
    </div>
  </div>
</div>

       

      <Footer />
    </div>
  );
};

export default Blog;